import React, { Component } from "react";
import propTypes from "prop-types";

import NowOnBruzzService from "services/NowOnBruzzService";

import ItemListItems from "./ItemListItems";

class NowOnBruzz extends Component {
  constructor() {
    super();

    this.state = {
      items: [],
      loading: true,
    };
  }

  componentDidMount = () => {
    this.refreshNowOnBruzz();
  };

  refreshNowOnBruzz = async () => {
    const { type } = this.props;

    try {
      const { items } = await NowOnBruzzService.getNowOnBruzzNews(type);

      this.setState({
        loading: false,
        items,
      });
    } catch (error) {
      console.log(error); // eslint-disable-line no-console
    }
  };

  render() {
    const { loading, items } = this.state;

    return loading ? (
      <div className="throbber" />
    ) : (
      <ItemListItems items={items} />
    );
  }
}

NowOnBruzz.propTypes = {
  type: propTypes.string.isRequired,
};

export default NowOnBruzz;
